import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamPartyState = {
  parties: [],
  restrictedParties: [],
}

export const TeamPartyActions = {
  getTeamParties: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/parties`).
      then(({ data }) => {
        commit('setTeamParties', data)
        return data
      }).
      catch(handleError)
  },

  excludeParty: async (_, { teamId, partyId }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/parties/${partyId}`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },

  getRestrictedParties: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/restricted_resources/parties`).
      then(({ data }) => {
        commit('setRestrictedParties', data)
        return data
      }).
      catch(handleError)
  },

  permitParty: async (_, { teamId, partyId }) => {
    return axiosRequest.
      post(`/teams/${teamId}/parties/${partyId}/permit`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },
}

export const TeamPartyGetters = {
  teamParties: state => state.parties || [],

  restrictedParties: state => (state.restrictedParties || []).map(party => ({
    ...party,
    type: 'Party',
  })),
}

export const TeamPartyMutations = {
  setTeamParties: (state, parties) => (state.parties = parties),
  setRestrictedParties: (state, parties) => (state.restrictedParties = parties),
}
